import React from 'react';
import { Typography } from '@naf-simba/building-blocks-typography';
import { ExpandLess, ExpandMore } from '@styled-icons/material';
import * as S from './ReadMoreButton.styles';

interface ReadMoreButtonProps {
  onToggle: () => void;
  isActive: boolean;
}

const ReadMoreButton = ({ isActive, onToggle }: ReadMoreButtonProps) => (
  <S.ShowMoreButton type="button" onClick={onToggle}>
    <Typography variant="textMRegular">Les mer</Typography>
    {isActive ? <ExpandLess size={24} /> : <ExpandMore size={24} />}
  </S.ShowMoreButton>
);

export default ReadMoreButton;
